// Server-side exports (Server Components, no 'use client')

// Auth helpers
export { getAuthFromCookies } from './InsforgeProvider';
export { auth } from './auth';
export type { InsforgeAuth } from './auth';

// Deprecated: Server Provider (doesn't work due to Next.js serialization constraints)
// Use InsforgeBrowserProvider directly in a client component instead
export {
  InsforgeServerProvider,
  InsforgeProvider, // Deprecated alias
  type InsforgeServerProviderProps,
  type InsforgeProviderServerProps, // Deprecated alias
} from './InsforgeProvider';
